module.exports = __webpack_public_path__ + "static/media/11NEPAD7.04eae424.jpg";